import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCreditCard = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M3 4C2.4375 4 2 4.46875 2 5L2 6L18 6V5C18 4.46875 17.5312 4 17 4L3 4ZM2 7V9L18 9V7L2 7ZM2 10L2 15C2 15.5625 2.4375 16 3 16L17 16C17.5313 16 18 15.5625 18 15L18 10L2 10ZM1 5C1 3.90625 1.875 3 3 3L17 3C18.0938 3 19 3.90625 19 5L19 15C19 16.125 18.0938 17 17 17H3C1.875 17 1 16.125 1 15L1 5ZM4 13.5C4 13.25 4.21875 13 4.5 13H6.5C6.75 13 7 13.25 7 13.5C7 13.7812 6.75 14 6.5 14H4.5C4.21875 14 4 13.7812 4 13.5ZM8 13.5C8 13.25 8.21875 13 8.5 13H12.5C12.75 13 13 13.25 13 13.5C13 13.7812 12.75 14 12.5 14H8.5C8.21875 14 8 13.7812 8 13.5Z"
	})
});
const ForwardRef = forwardRef(SvgCreditCard);
export default ForwardRef;
